import React, { useState } from 'react';
import styles from './UsedInMultiSelect.module.css';

// Tag-style multi-select used in two places: the concrete-mixes filter
// and conflict resolver, and the Daily Report concrete log entries.
// `options` are the project's Used-In list; clicking a chip toggles it.
// With `allowCustom`, an inline input appends free-text values not in
// the list (the field crew sometimes pours for elements that aren't
// catalogued yet — this lets them record exactly what they ordered).

export default function UsedInMultiSelect({ options, value, onChange, allowCustom = false }) {
  const [custom, setCustom] = useState('');

  function toggle(opt) {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  }
  function addCustom() {
    const v = custom.trim();
    if (!v) return;
    if (!value.includes(v)) onChange([...value, v]);
    setCustom('');
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.selected}>
        {value.length === 0 && <span className={styles.muted}>None selected</span>}
        {value.map((v) => (
          <span key={v} className={styles.tag}>
            {v}
            <button type="button" className={styles.tagX} onClick={() => toggle(v)}>×</button>
          </span>
        ))}
      </div>
      <div className={styles.options}>
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            className={`${styles.option} ${value.includes(opt) ? styles.optionActive : ''}`}
            onClick={() => toggle(opt)}
          >{opt}</button>
        ))}
        {allowCustom && (
          <span className={styles.custom}>
            <input
              className={styles.customInput}
              placeholder="Add other…"
              value={custom}
              onChange={(e) => setCustom(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
            />
            <button type="button" className={styles.customBtn} onClick={addCustom}>+</button>
          </span>
        )}
      </div>
    </div>
  );
}
